import React from "react";
import { Container, Typography, Paper } from "@mui/material";

const Support = () => {
  return (
    <Container maxWidth="sm" style={{ padding: "2rem 0" }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Support
      </Typography>

      <Paper elevation={2} style={{ padding: "2rem" }}>
        <Typography paragraph>
          If you have any questions, concerns, or need assistance with Trainer
          App, please reach out to us at:
        </Typography>

        <Typography variant="h6" color="primary">
          info@trainer-app.com
        </Typography>

        <Typography paragraph style={{ marginTop: "1rem" }}>
          Our team will do their best to respond to your inquiry as soon as
          possible.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Support;
